import { Pipe, PipeTransform } from '@angular/core';
import { Property } from '@app/shared/interfaces';

@Pipe({
  standalone: false,
  name: 'propertyIsInParentChildSetup',
})
export class PropertyIsInParentChildSetupPipe implements PipeTransform {
  transform(properties: Property[]): boolean {
    return properties.some((property) => property.parent_child_type !== null);
  }
}
